module.exports = __webpack_public_path__ + "static/media/soundAlpha.b2112366.mp3";